import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, FileSearch, Scale } from 'lucide-react';
export const HardTruth = () => {
  const observations = [{
    icon: <Clock size={20} className="text-sage" data-id="element-120" />,
    title: 'Поток',
    desc: 'В обычной клинике на приём отведено 10–15 минут. За это время невозможно детально изучить десятки срезов МРТ, выслушать историю и обдумать варианты.'
  }, {
    icon: <FileSearch size={20} className="text-sage" data-id="element-121" />,
    title: 'Описание вместо снимков',
    desc: 'Чаще всего смотрят короткое описание от рентгенолога, а не сами снимки. Важные нюансы остаются за кадром — особенно когда времени нет.'
  }, {
    icon: <Scale size={20} className="text-sage" data-id="element-122" />,
    title: 'Асимметрия ответственности',
    desc: 'Предложить операцию — безопаснее для врача, чем не предложить. Если станет хуже без операции — это вопрос к нему. Если операция оказалась не нужна — формально нет.'
  }];
  return <section className="py-28 bg-navy text-white relative overflow-hidden" data-id="element-123">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-sage opacity-5 rounded-full blur-3xl pointer-events-none" data-id="element-124" />

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-125">
        <FadeIn data-id="element-126">
          <div className="text-center mb-16" data-id="element-127">
            <span className="inline-block text-xs font-medium tracking-[0.2em] uppercase text-sage mb-4" data-id="element-128">
              Как это часто выглядит
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-white max-w-3xl mx-auto leading-tight" data-id="element-129">
              Что обычно происходит в кабинете
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-130">
          <blockquote className="relative max-w-3xl mx-auto mb-20" data-id="element-131">
            <div className="absolute -top-8 -left-2 font-serif text-8xl text-sage/30 leading-none select-none" data-id="element-132">
              "
            </div>
            <p className="font-serif text-xl md:text-2xl italic text-white/90 leading-relaxed pl-8 border-l-2 border-sage" data-id="element-133">
              Очередь. Двенадцать минут на приём. Врач читает описание МРТ — сам
              диск даже не открывает. «Возраст, грыжа большая, что вы хотите —
              надо резать». Следующий.
            </p>
            <div className="text-sm text-white/40 pl-8 mt-4 not-italic" data-id="element-134">
              — типичный сценарий, который слышим от наших клиентов
            </div>
          </blockquote>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-135">
          {observations.map((item, idx) => <FadeIn key={idx} delay={0.2 + idx * 0.1} data-id="element-136">
              <div className="bg-white/5 border border-white/10 backdrop-blur-sm p-7 rounded-2xl h-full" data-id="element-137">
                <div className="w-10 h-10 rounded-full bg-sage/15 flex items-center justify-center mb-5" data-id="element-138">
                  {item.icon}
                </div>
                <h3 className="font-medium text-white text-lg mb-3" data-id="element-139">
                  {item.title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed" data-id="element-140">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-141">
          <p className="text-center font-serif italic text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed" data-id="element-142">
            Это не злой умысел — это просто как устроена система. Но жить с её
            решениями придётся вам.
          </p>
        </FadeIn>
      </div>
    </section>;
};